import SwipeController from "./swipe_controller"

export default class extends SwipeController {
    static values = {
        threshold: {type: Number, default: 100},
        likeUrl: String,
        dislikeUrl: String
    }

    swipe() {
        if (this.isValidSwipe()) this.#actOnSwipe()

        this.clearTouch()
    }

    touchMove(event) {
        if (!this.startX) return

        const deltaX = this.clientX(event) - this.startX

        this.element.style.transform = `translateX(${deltaX}px) rotate(${deltaX * 0.1}deg)`
    }


    // private

    #actOnSwipe() {
        this.swipeDistance > 0 ? this.#like() : this.#dislike()
    }

    #like() {
        console.log(`Like card with URL: ${this.likeUrlValue}`)

        this.#animateOffScreen("right")
    }

    #dislike() {
        console.log(`Dislike card with URL: ${this.dislikeUrlValue}`)

        this.#animateOffScreen("left")
    }

    #animateOffScreen(direction) {
        const xOffset = direction === "right" ? window.innerWidth : -window.innerWidth
        const rotation = direction === "right" ? 30 : -30
        const animationDuration = 500 // in milliseconds

        this.element.style.transition = `transform ${animationDuration}ms ease-out`
        this.element.style.transform = `translateX(${xOffset}px) rotate(${rotation}deg)`

        setTimeout(() => {
            this.element.remove()
        }, animationDuration)
    }
}